import type { SVGProps } from "react";
export interface PartyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PartyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PartyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.172 12.172a1.126 1.126 0 0 1 1.506-.078l.085.078 6.066 6.066.077.085a1.126 1.126 0 0 1-1.583 1.583l-.085-.077-6.066-6.066-.078-.085a1.125 1.125 0 0 1 .078-1.506m12.972.76c.943-.314 1.82-.338 2.649-.061.6.2 1.113.537 1.567.928l.435.406.078.085a1.126 1.126 0 0 1-1.584 1.582l-.085-.076-.316-.296c-.302-.26-.562-.414-.806-.495-.296-.099-.669-.123-1.226.063a1.126 1.126 0 0 1-.712-2.136M15.9 10.676a1.125 1.125 0 0 1-1.798-1.352zM14.374 8.5A3.625 3.625 0 0 1 18 4.875c.76 0 1.375-.616 1.375-1.375 0-.815.27-1.57.726-2.175a1.125 1.125 0 1 1 1.798 1.35 1.37 1.37 0 0 0-.274.825A3.626 3.626 0 0 1 18 7.125c-.76 0-1.375.615-1.376 1.374 0 .815-.27 1.571-.725 2.177L15 10l-.899-.675c.173-.23.274-.514.274-.825Zm-6.17-6.294a1.125 1.125 0 0 1 1.506-.078l.085.078.406.435c.39.454.729.967.929 1.566.276.829.251 1.707-.063 2.65a1.125 1.125 0 1 1-2.135-.712c.186-.557.162-.93.063-1.226-.08-.244-.236-.504-.495-.806l-.296-.316-.077-.087a1.125 1.125 0 0 1 .077-1.504"
      />
      <path
        fill={color}
        d="M7.106 7.88a2.08 2.08 0 0 1 1.448.43l.21.188 6.739 6.738.186.21c.282.365.422.786.436 1.206A2.12 2.12 0 0 1 14.9 18.66q-.037.02-.076.038l-.001-.001-.016.008-10.303 4.218c-2.154.882-4.306-1.27-3.425-3.425L5.296 9.195l.007-.018A2.12 2.12 0 0 1 7.106 7.88M3.161 20.35a.375.375 0 0 0 .49.489l10.126-4.147-6.472-6.472zm15.979-2.718a1.375 1.375 0 1 1-1.507 1.51L17.625 19l.008-.14a1.375 1.375 0 0 1 1.366-1.235zm-5.202-1a.12.12 0 0 0-.06.08.14.14 0 0 0 .034.114l.076-.077zm5.202-8a1.375 1.375 0 1 1-1.507 1.51L17.625 10l.008-.14a1.375 1.375 0 0 1 1.366-1.235zM7.174 10.088c.01.01.029.024.055.031a.12.12 0 0 0 .136-.059l-.115-.05zM6.14 3.633A1.374 1.374 0 1 1 4.632 5.14L4.625 5l.007-.141A1.375 1.375 0 0 1 6 3.625zm8-1a1.376 1.376 0 1 1-1.51 1.508l-.007-.14.008-.141A1.375 1.375 0 0 1 14 2.625z"
      />
    </svg>
  );
}
